export const landingAsset = (name) =>
  `${process.env.PUBLIC_URL || ""}/landing-assets/${name}`;
